// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useEffect, useState } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { PinInput } from "react-input-pin-code";
import CompanyNotification from "app/company_notification";

// import { useNavigate } from "react-router-dom";
import axios from "axios.js";
import ApiConfig from "apiConfig";

function AirtimeIndex() {
  const pageTitle = "Buy Airtime & Data Bundles";
  usePageTitle(pageTitle);

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [pinValues, setPinValues] = useState(["", "", "", ""]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [networks, setNetworks] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [bundles, setBundles] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [amount, setAmount] = useState(null);

  const [selectedBundleNetwork, setSelectedBundleNetwork] = useState(null);
  const [phoneNumberBundle, setPhoneNumberBundle] = useState(null);
  const [networkBundles, setNetworkBundles] = useState([]);
  const [selectedBundle, setSelectedbundle] = useState(null);

  const [userPin, setUserPin] = useState(null);
  const [submitType, setSubmitType] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("bp/airtime/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setNetworks(result.data.data.networks);
            setBundles(result.data.data.bundles);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("transfer-bank")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function handleAirtimeSubmit() {
    if (selectedNetwork === null) {
      setSeverity("error");
      setErrMsg("Please select a mobile network");
      setOpen(true);
      return;
    }

    if (amount === null) {
      setSeverity("error");
      setErrMsg("Please enter an amount");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Please enter a valid phone number");
      setOpen(true);
      return;
    }

    setPinValues(["", "", "", ""]);
    setSubmitType("AIRTIME");
    setShowConfirmDialog(true);
  }

  async function purchaseAirtime() {
    if (selectedNetwork === null) {
      setSeverity("error");
      setErrMsg("Please select a mobile network");
      setOpen(true);
      return;
    }

    if (amount === null) {
      setSeverity("error");
      setErrMsg("Please enter an amount");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Please enter a valid phone number");
      setOpen(true);
      return;
    }

    const params = {
      amount: amount * 100,
      phone_number: phoneNumber,
      network: selectedNetwork,
      country: "NG",
      pin: userPin,
    };

    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("bp/airtime/purchase.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  }

  function handleDataSubmit() {
    if (selectedBundleNetwork === null) {
      setSeverity("error");
      setErrMsg("Please select a mobile network");
      setOpen(true);
      return;
    }

    if (selectedBundle === null) {
      setSeverity("error");
      setErrMsg("Please select a data bundle");
      setOpen(true);
      return;
    }

    if (phoneNumberBundle === null) {
      setSeverity("error");
      setErrMsg("Please enter a valid phone number");
      setOpen(true);
      return;
    }

    setPinValues(["", "", "", ""]);
    setSubmitType("DATA");
    setShowConfirmDialog(true);
  }

  async function purchaseData() {
    if (selectedBundleNetwork === null) {
      setSeverity("error");
      setErrMsg("Please select a mobile network");
      setOpen(true);
      return;
    }

    if (selectedBundle === null) {
      setSeverity("error");
      setErrMsg("Please select a data bundle");
      setOpen(true);
      return;
    }

    if (phoneNumberBundle === null) {
      setSeverity("error");
      setErrMsg("Please enter a valid phone number");
      setOpen(true);
      return;
    }

    const params = {
      bundle: selectedBundle,
      phone_number: phoneNumberBundle,
      network: selectedBundleNetwork,
      country: "NG",
      pin: userPin,
    };

    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("bp/bundle/purchase.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <Dialog open={showConfirmDialog}>
        <DialogTitle>Authorize Transaction</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="h6" fontWeight="light">
              Enter your pin to authorize transaction.
            </MDTypography>
            <MDBox mt={2}>
              <PinInput
                values={pinValues}
                onChange={(value, index, values) => setPinValues(values)}
                length={4}
                mask
                autoTab
                placeholder="-"
                onComplete={(text) => {
                  let up = "";
                  text.forEach((itm) => {
                    up += itm;
                  });
                  setUserPin(up);
                }}
              />
            </MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setShowConfirmDialog(false);
            }}
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              if (userPin !== null && userPin.length === 4) {
                setShowConfirmDialog(false);
                if (submitType === "AIRTIME") {
                  purchaseAirtime();
                } else {
                  purchaseData();
                }
              }
            }}
          >
            Authorize
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3} mb={10}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6} lg={6}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" fontWeight="medium">
                  Buy Airtime
                </MDTypography>
                <MDBox mt={3}>
                  <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Mobile Network</InputLabel>
                      <Select
                        label="Mobile Network"
                        onChange={(e) => setSelectedNetwork(e.target.value)}
                        sx={{ padding: "10px", paddingLeft: "3px" }}
                        value={selectedNetwork || ""}
                      >
                        {
                          // --> Notice below changes
                          networks.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            networks.map((record) => (
                              <MenuItem value={record.code}>
                                <MDBox display="flex" alignItems="center" justifyContent="left">
                                  <img
                                    alt=""
                                    src={`${ApiConfig.api_media_url}${record.logo}`}
                                    width="20"
                                    mr={3}
                                  />
                                  <MDBox ml={2}>{record.title}</MDBox>
                                </MDBox>
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mb={3}>
                    <MDInput
                      name="amount"
                      label="Amount"
                      sx={{ minWidth: 120, width: "100%" }}
                      onChange={(e) => setAmount(e.target.value)}
                      value={amount || ""}
                    />
                  </MDBox>
                  <MDBox mb={3}>
                    <MDInput
                      name="phone_number"
                      label="Phone Number"
                      sx={{ minWidth: 120, width: "100%" }}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      value={phoneNumber || ""}
                    />
                  </MDBox>
                  <MDBox mb={3} mt={5} display="flex" justifyContent="center">
                    <MDButton
                      variant="outlined"
                      color="info"
                      sx={{ width: "100%" }}
                      onClick={() => {
                        handleAirtimeSubmit();
                        // purchaseAirtime();
                      }}
                    >
                      Buy Airtime
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" fontWeight="medium">
                  Buy Data
                </MDTypography>
                <MDBox mt={3}>
                  <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Mobile Network</InputLabel>
                      <Select
                        label="Mobile Network"
                        onChange={(e) => {
                          setSelectedBundleNetwork(e.target.value);
                          setNetworkBundles(bundles[e.target.value]);
                        }}
                        sx={{ padding: "10px", paddingLeft: "3px" }}
                      >
                        {
                          // --> Notice below changes
                          networks.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            networks.map((record) => (
                              <MenuItem value={record.code}>
                                <MDBox display="flex" alignItems="center" justifyContent="left">
                                  <img
                                    alt=""
                                    src={`${ApiConfig.api_media_url}${record.logo}`}
                                    width="20"
                                    mr={3}
                                  />
                                  <MDBox ml={2}>{record.title}</MDBox>
                                </MDBox>
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Data Bundle</InputLabel>
                      <Select
                        label="Data Bundle"
                        onChange={(e) => setSelectedbundle(e.target.value)}
                        sx={{ padding: "10px", paddingLeft: "3px" }}
                      >
                        {
                          // --> Notice below changes
                          networkBundles.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            networkBundles.map((record) => (
                              <MenuItem value={record.code}>
                                {record.name} | N{record.amount}
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mb={3}>
                    <MDInput
                      name="phone_number"
                      label="Phone Number"
                      sx={{ minWidth: 120, width: "100%" }}
                      onChange={(e) => setPhoneNumberBundle(e.target.value)}
                      value={phoneNumberBundle || ""}
                    />
                  </MDBox>
                  <MDBox mb={3} mt={5} display="flex" justifyContent="center">
                    <MDButton
                      variant="outlined"
                      color="dark"
                      sx={{ width: "100%" }}
                      onClick={() => {
                        handleDataSubmit();
                        // purchaseData();
                      }}
                    >
                      Buy Data
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AirtimeIndex;
